import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import localeText from "../../../locale";

const InviteCouponField = ({
  hasInviteCoupon,
  setHasInviteCoupon,
  inviteCoupon,
  setInviteCoupon,
  loading,
}) => {
  return (
    <div className="field">
      <div className="flex align-items-start gap-2">
        <Checkbox
          inputId="hasInviteCoupon"
          checked={hasInviteCoupon}
          onChange={(e) => {
            setHasInviteCoupon(e.checked);
            if (!e.checked) {
              setInviteCoupon("");
            }
          }}
          disabled={loading}
        />
        <label htmlFor="hasInviteCoupon" className="text-sm" style={{ color: "#344563" }}>
          {localeText("iHaveInviteCoupon")}
        </label>
      </div>

      {hasInviteCoupon && (
        <>
          <label className="font-semibold text-sm mt-2" htmlFor="inviteCoupon" style={{ color: "#0D0D0E" }}>
            {localeText("coupon")}
          </label>
          <InputText
            id="inviteCoupon"
            name="inviteCoupon"
            type="text"
            value={inviteCoupon}
            onChange={(e) => setInviteCoupon(e.target.value)}
            disabled={loading}
            className="w-full p-3 mt-2"
            placeholder={localeText("enterInviteCoupon")}
          />
        </>
      )}
    </div>
  );
};

export default InviteCouponField;
